import { FC } from "react";

import styles from "./styles.module.scss";

interface IProps {
    checked: boolean;
    onChange(): void;
}

const Switch: FC<IProps> = ({ checked, onChange }) => {
    return (
        <div className={styles.switch} onClick={onChange}>
            <input type="checkbox" onChange={onChange} checked={checked} />
            <label>
                <button>
                    <svg width="20" height="12.72" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M14.6364 1H7.36364C3.8491 1 1 3.68629 1 7C1 10.3137 3.8491 13 7.36364 13H14.6364C18.1509 13 21 10.3137 21 7C21 3.68629 18.1509 1 14.6364 1Z"
                            stroke="currentcolor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 5C4.10457 5 5 4.10457 5 3C5 1.89543 4.10457 1 3 1C1.89543 1 1 1.89543 1 3C1 4.10457 1.89543 5 3 5Z"
                            stroke="currentcolor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </label>
        </div>
    );
};

export default Switch;
